import { supabase } from "./supabase";

function mapProduct(row) {
  return {
    id: row.id,
    slug: row.slug,
    kind: "product",
    name: row.name,
    category: row.category,
    commonName: row.common_name,
    size: row.net_quantity,
    price: row.price_paise / 100,
    pricePaise: row.price_paise,
    badge: row.badge,
    cardLine: row.card_line,
    short: row.short_desc,
    keyIngredients: row.key_ingredients ?? [],
    fullIngredients: row.full_ingredients,
    howToUse: row.how_to_use ?? [],
    images: row.images ?? [],
    stock: row.stock,
    inStock: row.stock > 0,
    bestseller: row.bestseller,
    sortOrder: row.sort_order,
  };
}

function mapSet(row) {
  return {
    id: row.id,
    slug: row.slug,
    kind: "set",
    name: row.name,
    category: "Sets & Gifting",
    price: row.price_paise / 100,
    pricePaise: row.price_paise,
    note: row.note,
    images: row.image ? [row.image] : [],
    contents: (row.set_items ?? []).map((si) => si.products?.name).filter(Boolean),
    sortOrder: row.sort_order,
  };
}

function markEntry(products) {
  if (!products.length) return products;
  let cheapest = products[0];
  for (const p of products) if (p.price < cheapest.price) cheapest = p;
  return products.map((p) => ({ ...p, entry: p.id === cheapest.id }));
}

const PRODUCT_COLS =
  "id,slug,name,category,common_name,net_quantity,price_paise,badge," +
  "card_line,short_desc,key_ingredients,full_ingredients,how_to_use," +
  "images,stock,active,bestseller,sort_order";

export async function fetchProducts() {
  const { data, error } = await supabase
    .from("products")
    .select(PRODUCT_COLS)
    .eq("active", true)
    .order("sort_order", { ascending: true });
  if (error) throw error;
  return markEntry((data ?? []).map(mapProduct));
}

export async function fetchProductBySlug(slug) {
  const { data, error } = await supabase
    .from("products")
    .select(PRODUCT_COLS)
    .eq("slug", slug)
    .eq("active", true)
    .maybeSingle();
  if (error) throw error;
  return data ? mapProduct(data) : null;
}

export async function fetchSets() {
  const { data, error } = await supabase
    .from("sets")
    .select("id,slug,name,price_paise,note,image,active,sort_order,set_items(qty,products(name))")
    .eq("active", true)
    .order("sort_order", { ascending: true });
  if (error) throw error;
  return (data ?? []).map(mapSet);
}

export async function fetchCatalogue() {
  const [products, sets] = await Promise.all([fetchProducts(), fetchSets()]);
  return { products, sets };
}
